import { palette } from '@app/theme';

import type { NoteVariant } from './Note.types';

export const ICON_COLORS: Record<NoteVariant, string> = {
  error: palette.error.main,
  warning: palette.warning.main,
  info: palette.primary.main,
  success: palette.success.main,
};
